import React, { useState, useEffect } from "react";

import { Box, Paper, Grid, Typography, Button, TextField } from "@mui/material";

import TopViewNav from "../CommonComponents/TopViewNav";

import MapComponent from "../Dashboard/Map";

import { DetailsAction } from "../../actions/details";
import moment from "moment";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "../OutdoorDuties/Report.css";
import { useParams } from "react-router-dom";
import "./responsive.css";
import { dynamiceForm } from "../../actions/DynamiceForm";
import { GeofenceAction } from "../../actions/Geofence";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import CheckinCheckoutModal from "./CheckinCheckoutModal";
import GpsLocationStatus from "./GpsLocationStatus";
// {
//     "userId": "146",
//     "fromDate": "2022-11-24",
//     "toDate": "2022-11-24"
// }
const url = window.location.pathname;
const DetailsData = () => {
  const params = window.location.href.split("?")[1].split("&");
  let obj = [];

  params.forEach((ele) => {
    obj.push(ele.split("=")[1]);
  });

  const newObj = obj.map((ele, i) => {
    if (i == 1 || i == 2) {
      return ele.slice(0, 13);
    } else return ele;
  });
  console.log(newObj, "edwefe");

  const query = new URLSearchParams(window.location.search);

  const [details, setDetails] = useState([]);
  const [NewClientTitle, setNewClientTitle] = React.useState("");
  const [UniqueClients, setUniqueClients] = useState("");
  console.log(details, "details");
  const topViewNavData = {
    // title: "OD Details",
    title: "View Route",
    backPath: "OD Duties",
    backPathRoute: "/outdoorduties",
  };

  const [hasGeofencePermission, setHasGeofencePermission] = useState(false);
  const [geofenceToShow, setGeofenceToShow] = useState(false);
  const [userWiseGeofences, setUserWiseGeofences] = useState([]);
  console.log("userWiseGeofences : ", userWiseGeofences);

  const [openGeofenceSessionsModal, setOpenGeofenceSessionsModal] =
    useState(false);

  const [selectedGeofenceData, setSelectedGeofenceData] = useState(null);

  const [isShowGPSLocationStatusActive, setIsShowGPSLocationStatusActive] =
    useState(false);

  const [locationTrackingDetailsV2, setLocationTrackingDetailsV2] = useState(
    [],
  );

  const [gpsLocationStatusData, setGpsLocationStatusData] = useState([]);

  const handleOpenGeofenceSessionsModal = (selectedData) => {
    // setSelectedGeofenceData(selectedData);
    setSelectedGeofenceData(selectedData);
    setOpenGeofenceSessionsModal(true);
  };
  const handleCloseGeofenceSessionsModal = () => {
    setSelectedGeofenceData(null);
    setOpenGeofenceSessionsModal(false);
  };

  const handleToggleGeofenceToShow = () => {
    setGeofenceToShow((prev) => !prev);
  };

  const fetchClientBaseEmpForUsers = () => {
    const data = {
      companyId: Number(newObj[5]) || null,
    };
    companyWiseEmp.fetchCompnyWiseUpdate(data).then((response) => {
      if (response !== null && response.responseCode === 200) {
        const showGPSLocationStatusToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "GPS_LOCATION_STATUS",
          );
        setIsShowGPSLocationStatusActive(
          showGPSLocationStatusToSet && showGPSLocationStatusToSet.length > 0
            ? showGPSLocationStatusToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        const enableGeofenceManagementToSet =
          response.data &&
          response.data.filter(
            (val) => val.hrmsConfigurationName === "ENABLE_GEOFENCE_MANAGEMENT",
          );
        setHasGeofencePermission(
          enableGeofenceManagementToSet &&
            enableGeofenceManagementToSet.length > 0
            ? enableGeofenceManagementToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
        setGeofenceToShow(
          enableGeofenceManagementToSet &&
            enableGeofenceManagementToSet.length > 0
            ? enableGeofenceManagementToSet[0].isEnable === true
              ? true
              : false
            : false,
        );
      }
    });
  };

  const fetchGeofenceWithTrail = async () => {
    try {
      // 1. Get all geofences
      const geoRes = await GeofenceAction.getGeofenceList({
        companyId: Number(newObj[5]) || null,
        ...(Number(newObj[3])
          ? {
              userId: Number(newObj[3]),
            }
          : {}),
      });

      if (!geoRes || geoRes.responseCode !== 200) return;

      const geofenceArr = Boolean(geoRes?.data?.length > 0)
        ? geoRes?.data?.map((item, index) => ({
            ...item,
            coordinatesDTOList: [
              {
                id: index + 1,
                latitude: item?.latitude,
                longitude: item?.longitude,
                color: item?.color,
                geofenceType: item?.geofenceType,
                name: item?.name,
                radius: item?.radius,
                zoomLevel: item?.zoomLevel,
                trailData: [],
              },
            ],
          }))
        : [];

      // 2. If geofence exists → get trails
      if (geofenceArr.length > 0) {
        const trailRes = await GeofenceAction.getGeofencesTrailData({
          companyId: Number(newObj[5]) || null,
          ...(Number(newObj[3])
            ? {
                userId: Number(newObj[3]),
              }
            : {}),
        });

        if (trailRes && trailRes.responseCode === 200) {
          const trailArr = trailRes?.data || [];

          // 3. Merge logic
          const mergedArr = geofenceArr
            .map((geoItem) => {
              const matchedTrail = trailArr.find(
                (trailItem) => trailItem?.geofenceId === geoItem?.id,
              );

              return {
                ...geoItem,
                coordinatesDTOList: [
                  {
                    ...geoItem?.coordinatesDTOList[0],
                    trailData: matchedTrail?.trailData || [],
                  },
                ],
              };
            })
            ?.flatMap((updtItem) => updtItem?.coordinatesDTOList);

          setUserWiseGeofences(mergedArr);
          return;
        }
      }

      // fallback if no trail data
      setUserWiseGeofences(
        geofenceArr?.flatMap((updtItem) => updtItem?.coordinatesDTOList),
      );
    } catch (err) {
      console.log("Error in fetching geofence + trail:", err);
    }
  };

  const getLostDistanceDetails = async (singleDetail) => {
    // const singleDetail = JSON.parse(localStorage.getItem("singleDetail"));
    // const hrmsUserId = JSON.parse(localStorage.getItem("data"))?.hrmsUserId;
    // singleDetail.hrmsUserId = hrmsUserId;
    // singleDetail.companyId = JSON.parse(
    //   localStorage.getItem("data"),
    // )?.hrmsCompanyId;
    // singleDetail.locationTrackingFrequency = JSON.parse(
    //   localStorage.getItem("data"),
    // ).locationTrackingFrequency;
    const res = await DetailsAction.fetchLostDistanceDetails(singleDetail);
    if (res !== null) {
      if (res.responseCode === 200 && res.data?.length > 0) {
        return res.data;
      } else {
        return [];
      }
    } else {
      return [];
    }
  };

  console.log(newObj);

  const getDistanceDetails = async () => {
    const singleDetail = {
      filterUserId: Number(newObj[0]),
      fromDate: newObj[1],
      hrmsUserId: Number(newObj[4]),
      toDate: newObj[2],
      userId: Number(newObj[3]),
      companyId: Number(newObj[5]) || null,
      locationTrackingFrequency: Number(newObj[6]) || null,
      id: Number(newObj[7]) || null,
    };
    //const singleDetail = JSON.parse(localStorage.getItem("singleDetail"));

    let dynamicSingleDetail = {};

    query.forEach((value, key) => {
      if (!isNaN(value) && value.trim() !== "") {
        dynamicSingleDetail[key] = Number(value);
      } else {
        dynamicSingleDetail[key] = value;
      }
    });
    console.log(dynamicSingleDetail, "dynamicSingleDetail");
    //const hrmsUserId = JSON.parse(localStorage.getItem("data"))?.hrmsUserId;
    singleDetail.hrmsUserId = singleDetail.hrmsUserId;

    const res = await DetailsAction.fetchDistanceDetails(
      dynamicSingleDetail?.hasOwnProperty("id")
        ? dynamicSingleDetail
        : singleDetail,
    );
    if (res !== null) {
      if (res.responseCode === 200) {
        debugger;
        setDetails(res.data && res.data.dataList && res.data.dataList);
        const lostDistanceDetails = await getLostDistanceDetails(singleDetail);
        const locationTrackingDetailsToSet = [];
        const locationTrackingDetailsV2 = [];

        function transform(data) {
          let totalMinutes = 0;
          let autoDetectMinutes = 0;
          let manualDetectMinutes = 0;

          const result = data
            ?.map((pair) => {
              if (pair.length < 2) return null;

              const start = moment.utc(pair[0].isLocationDetectedTime);
              const end = moment.utc(pair[1].isLocationDetectedTime);

              const minutes = end.diff(start, "minutes");

              // Overall total
              totalMinutes += minutes;

              // Auto / Manual total
              if (pair[0].isLostAutoDetect === true) {
                autoDetectMinutes += minutes;
              } else {
                manualDetectMinutes += minutes;
              }

              return {
                time: `${start.local().format("h:mm A")} - ${end
                  .local()
                  .format("h:mm A")}`,
                hours: Math.floor(minutes / 60),
                minutes: minutes % 60,
                duration: `${Math.floor(minutes / 60)}h ${minutes % 60}m`,
                isLostAutoDetect: pair[0].isLostAutoDetect,
              };
            })
            .filter(Boolean);

          // Helper function
          const formatDuration = (minutes) => ({
            hours: Math.floor(minutes / 60),
            minutes: minutes % 60,
            duration: `${Math.floor(minutes / 60)}h ${minutes % 60}m`,
          });

          const total = formatDuration(totalMinutes);
          const autoDetect = formatDuration(autoDetectMinutes);
          const manualDetect = formatDuration(manualDetectMinutes);

          return {
            data: result,

            // Overall
            totalHours: total.hours,
            totalMinutes: total.minutes,
            totalDuration: total.duration,

            // Auto Detect
            autoDetectTotalHours: autoDetect.hours,
            autoDetectMinutes: autoDetect.minutes,
            autoDetectDuration: autoDetect.duration,

            // Manual Detect
            manuaDetectTotalHours: manualDetect.hours,
            manuaDetectMinutes: manualDetect.minutes,
            manuaDetectDuration: manualDetect.duration,
          };
        }
        res?.data?.dataList?.forEach((od) => {
          const result = transform(lostDistanceDetails) || [];
          console.log(result);
          const startTime =
            od?.createdDate && moment(od?.createdDate).format("h:mm A");
          const endTime = od?.date && moment(od?.date).format("h:mm A");
          setGpsLocationStatusData(
            ...gpsLocationStatusData,
            lostDistanceDetails,
          );
          const finalData = [
            {
              time: startTime,
              isGreen: true,
              startTime: od?.createdDate && moment(od?.createdDate),
            },
            ...(result?.data ?? []),
            {
              time: endTime,
              isGreen: true,
              endTime: od?.date && moment(od?.date),
            },
          ];
          setLocationTrackingDetailsV2((prev) => [...prev, ...finalData]);
        });
      }
    }
  };

  const fetchHederTitle = () => {
    const Templatedata = {
      companyId:
        newObj && newObj !== null && newObj !== undefined
          ? Number(newObj[5])
          : null,
      templateTypeId: 5,
    };
    dynamiceForm.fetchGetSaveTempalte(Templatedata).then((response) => {
      if (response !== null) {
        const NewClient =
          response.data &&
          response.data.templateDateForAindroid !== null &&
          response.data.templateDateForAindroid.filter((val) => {
            if (val.actualName === "New Client") {
              return setNewClientTitle(val.displayName);
            }
          });
        const NewClientCount =
          response.data &&
          response.data.templateDateForAindroid !== null &&
          response.data.templateDateForAindroid.filter((val) => {
            if (val.actualName === "Unique Clients") {
              return setUniqueClients(val.displayName);
            }
          });
      }
    });
  };

  let startDate = details[0]?.createdDate;

  console.log(moment(startDate).format("DD/MM/YYYY"));

  useEffect(() => {
    fetchHederTitle();
    getDistanceDetails();
  }, []);

  useEffect(() => {
    if (Number(newObj[5])) {
      fetchClientBaseEmpForUsers();
    }
  }, [Number(newObj[5])]);

  useEffect(() => {
    if (Boolean(details?.length > 0) && details[0]?.userId) {
      fetchGeofenceWithTrail();
    }
  }, [details]);

  return (
    <main className="contents__root">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TopViewNav topViewNavData={topViewNavData} isDetails={true} />
        </Grid>
        <Grid item xs={12}>
          <Box
            className="mein_view"
            component={Paper}
            sx={{
              padding: "0.75rem",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} className="details_page">
                <Box className="top_table_status view_map">
                  <Grid container>
                    {/* <Grid item md={12} sm={12} lg={4} pr={1}> */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: "6px",
                          width: "100%",
                          marginBottom: "5px",
                        }}
                      >
                        <div
                          className="field_box field_toggle"
                        >
                          <div>
                            {details[0]?.userName}{" "}
                            {details[0]?.empCode
                              ? `(${details[0].empCode})`
                              : null}
                          </div>
                        </div>
                        <div className="date_container">
                          <span className="title">Date</span>
                          <span className="date">
                            {moment(startDate).format("DD/MM/YYYY")}
                          </span>
                        </div>
                      </Box>
                    {/* </Grid> */}
                    <Grid item md={8}>
                      <Box
                        className="right_status_colors"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          height: "100%",
                        }}
                      >
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#F4ECB5",
                          }}
                        >
                          <span>Total Meetings</span>
                          <span className="count_bx">
                            {/* {details[0]?.clientCommunicationDtoList.length} */}
                            {/* {details[0] &&
                            details[0].clientCommunicationDtoList &&
                            details[0].clientCommunicationDtoList.length
                              ? details[0].totalVisit
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details.reduce((prev, curr) => {
                                  if (curr.totalVisit) {
                                    return prev + curr.totalVisit;
                                  }
                                  return prev;
                                }, 0)
                              : "N/A"}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#E1EDC4",
                          }}
                        >
                          <span>
                            {NewClientTitle !== ""
                              ? NewClientTitle
                              : "New Clients"}
                          </span>
                          <span className="count_bx">
                            {/* {details[0]?.totalClientNewCommunication} */}
                            {/* {details[0] &&
                            details[0].totalClientNewCommunication
                              ? details[0].totalClientNewCommunication
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details.reduce((prev, curr) => {
                                  if (curr.totalClientNewCommunication) {
                                    return (
                                      prev + curr.totalClientNewCommunication
                                    );
                                  }
                                  return prev;
                                }, 0)
                              : "N/A"}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#ECD0EF",
                          }}
                        >
                          <span>
                            {UniqueClients !== ""
                              ? UniqueClients
                              : "Unique Clientss"}
                          </span>
                          <span className="count_bx">
                            {/* {details[0] && DETAIL?.totalUniqueClient} */}
                            {/* {details[0] && details[0].totalUniqueClient
                              ? details[0].totalUniqueClient
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details.reduce((prev, curr) => {
                                  if (curr.totalUniqueClient) {
                                    return prev + curr.totalUniqueClient;
                                  }
                                  return prev;
                                }, 0)
                              : "N/A"}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#ECD0EF",
                          }}
                        >
                          <span>Total Distance(Kms) </span>
                          <span className="count_bx">
                            {/* {details[0] && details[0].totalDistance
                              ? details[0].totalDistance
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details
                                  .reduce((prev, curr) => {
                                    if (curr.totalDistance) {
                                      return prev + curr.totalDistance;
                                    }
                                    return prev;
                                  }, 0)
                                  .toFixed(2)
                              : "N/A"}
                          </span>
                        </div>
                        <div
                          className="field_toggle"
                          style={{
                            backgroundColor: "#ECD0EF",
                          }}
                        >
                          <span>Daily Distance Fare (₹)</span>
                          <span className="count_bx">
                            {/* {details[0]?.totalAmountForOd.toFixed() || "N/A"} */}
                            {/* {details[0] && details[0].totalAmountForOd
                              ? details[0].totalAmountForOd.toFixed()
                              : "N/A"} */}
                            {Boolean(details) && Boolean(details.length)
                              ? details
                                  .reduce((prev, curr) => {
                                    if (curr.totalAmountForOd) {
                                      return prev + curr.totalAmountForOd;
                                    }
                                    return prev;
                                  }, 0)
                                  .toFixed(2)
                              : "N/A"}
                          </span>
                        </div>
                      </Box>
                    </Grid>
                    {Boolean(locationTrackingDetailsV2) &&
                      Boolean(isShowGPSLocationStatusActive) && (
                        <Grid item xs={12}>
                          <GpsLocationStatus
                            // data={dummyGpsData}
                            // time={dummyGpsTime}
                            data={gpsLocationStatusData}
                            time={locationTrackingDetailsV2}
                            layout={{
                              itemsPerRow: 2, // how many nodes before it wraps to the next row
                              rowHeight: 150, // vertical spacing between rows
                              colWidth: 220, // horizontal spacing between nodes
                              nodeRadius: 28, // size of the colored circle markers
                              timeGap: 5, // gap between circle and the time label above it
                              chipGap: 5, // gap between circle and the status chip below it
                              padding: 30, // breathing room around the whole diagram
                              startX: 90, // x of the first node
                              row0Y: 90, // y of the first row
                            }}
                          />
                        </Grid>
                      )}
                  </Grid>
                </Box>
                <MapComponent
                  isDetails={true}
                  details={details}
                  userWiseGeofences={userWiseGeofences}
                  hasGeofencePermission={hasGeofencePermission}
                  geofenceToShow={geofenceToShow}
                  handleToggleGeofenceToShow={handleToggleGeofenceToShow}
                  handleOpenGeofenceSessionsModal={
                    handleOpenGeofenceSessionsModal
                  }
                />

                <CheckinCheckoutModal
                  open={openGeofenceSessionsModal}
                  onClose={handleCloseGeofenceSessionsModal}
                  geofenceData={selectedGeofenceData}
                  geofenceName={selectedGeofenceData?.name || ""}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </main>
  );
};

export default DetailsData;
